export default {
  name: 'Bosnia and Herzegovina',
  phonePattern: '061123456',
  postalCodePattern: '11111',
  singlePostalCode: '',
  postalCodeRegex: '^[\\d]{5}$',
  language: '',
  dobFormat: 'YY-MM-DD'
}



// WEBPACK FOOTER //
// ./src/locales/countries/BA.js